
<template>
   <div>

   <v-layout row wrap>
      <v-flex xs12>
         <v-toolbar color="brown lighten-2" dark>
            <v-toolbar-title>{{ mealNames[index] }}, {{ displayDate }}</v-toolbar-title>
         </v-toolbar>

         <v-card>

            <v-list two-line>
               <v-btn @click="addMealElement"
                     fab small color="yellow"
                     top right absolute>
                  <v-icon>add</v-icon>
               </v-btn>

               <template v-for="(mealElement, index) in mealElements">
                  <v-list-tile avatar :key="mealElement.id">
                     <v-list-tile-avatar>
                        <v-btn icon large ripple v-if="mealElement.food_pict" @click.stop="mealElementToZoomIn = mealElement; zoomImage = true">
                           <img :src="pictPath(mealElement.food_pict)">
                        </v-btn>
                     </v-list-tile-avatar>
                     <v-list-tile-content>
                        <v-list-tile-title>{{ mealElement.food_name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ mealElementQuantityDescription(mealElement) }}</v-list-tile-sub-title>
                     </v-list-tile-content>
                     <v-list-tile-action>
                        <v-btn icon ripple @click.stop="editMealElement(mealElement)">
                           <v-icon color="grey lighten-1">edit</v-icon>
                        </v-btn>
                        <v-btn icon ripple @click.stop="mealElementToDelete = clone(mealElement); deleteDialog = true">
                           <v-icon color="grey lighten-1">delete</v-icon>
                        </v-btn>
                     </v-list-tile-action>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < mealElements.length" :key="mealElement.id + '-'"></v-divider>
               </template>
            </v-list>

            <v-card-text v-if="mealElements.length === 0" style="height: 80px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>
         </v-card>
      </v-flex>

      <v-dialog v-model="zoomImage" persistent max-width="800">
         <v-card>
            <v-card-text>
               <img :src="pictPath(mealElementToZoomIn.food_pict)" style="width: 100%;">
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="brown darken-2" flat @click.native="zoomImage = false">OK</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" persistent max-width="400">
         <v-card>
            <v-card-title class="headline grey lighten-2">Confirmer</v-card-title>
            <v-card-text>Supprimer {{ mealElementToDelete.food_name }} ?</v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false; deleteMealElement()">Supprimer</v-btn>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="editDialog" persistent max-width="600">
         <v-form>
            <v-card>
               <v-card-title class="headline grey lighten-2" v-if="create">Nouvel aliment</v-card-title>
               <v-card-text>
                  <v-container>
                     <v-layout wrap>
                        <v-flex xs12 v-if="!choosenFood">
                           <!-- this is where foodObject comes from -->
                           <v-autocomplete
                              label="Aliment (taper une partie du nom)"
                              :loading="foodSearchLoading"
                              cache-items
                              item-text="shrt_desc"
                              required
                              :items="foodItems"
                              :search-input.sync="foodSearchInput"
                              v-model="choosenFood"
                              return-object
                           ></v-autocomplete>
                        </v-flex>

                        <v-flex xs11 v-if="choosenFood">
                           <div class="title">{{ choosenFood.shrt_desc }}</div>
                        </v-flex>
                        <v-flex xs1 v-if="choosenFood">
                           <v-btn icon ripple @click.stop="changeFood()">
                              <v-icon color="grey lighten-1">edit</v-icon>
                           </v-btn>
                        </v-flex>

                        <v-flex xs7 v-if="choosenFoodPortions && (choosenFoodPortion || choosenFoodPortions.length === 1)">
                           <img :src="pictPath(choosenFoodPortion.pict)" height="150"></img>
                        </v-flex>
                        <v-flex xs4 v-if="choosenFoodPortions && (choosenFoodPortion || choosenFoodPortions.length === 1)">
                           <div class="title">{{ choosenFoodPortion.longuest_desc }}</div>
                        </v-flex>
                        <v-flex xs1 v-if="choosenFoodPortions && (choosenFoodPortion || choosenFoodPortions.length === 1)">
                           <v-btn icon ripple @click.stop="changeFoodPortion" v-if="choosenFoodPortions.length > 1">
                              <v-icon color="grey lighten-1">edit</v-icon>
                           </v-btn>
                        </v-flex>

                        <v-flex xs12 v-if="choosenFoodPortions && !choosenFoodPortion && choosenFoodPortions.length > 1">
                           <v-layout row wrap>
                              <div v-for="foodPortion in choosenFoodPortions">
                                 <a @click="chooseFoodPortion(foodPortion)">
                                    <img :src="pictPath(foodPortion.pict)" height="110" class="portionImg"></img>
                                 </a>
                              </div>
                           </v-layout>
                        </v-flex>

                        <v-flex xs12 v-if="choosenFoodPortions && choosenFoodPortion">
                           <v-slider
                              v-model="choosenFoodPortionCount"
                              :tick-labels="tickLabels"
                              ttthumb-label
                              always-dirty
                              :max="5"
                              :min="0.25"
                              step="0.25"
                              ticks="always"
                              tick-size="1"
                              @change="$v.choosenWeight.$touch(); onSliderChange($event)"
                           ></v-slider>
                        </v-flex>

                        <v-flex xs12 v-if="choosenFood">
                           <v-text-field 
                              label="Poids (g)"
                              v-model="choosenWeight"
                              @keyup.enter.native="debouncedCreateOrUpdate"
                              :error-messages="choosenWeightErrors"
                              @input="$v.choosenWeight.$touch(); onWeightChangeDebounced(choosenWeight)"
                              blur="$v.choosenWeight.$touch()">
                           </v-text-field>
                        </v-flex>

                     </v-layout>
                  </v-container>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="brown darken-2" flat @click.native="debouncedCreateOrUpdate()" :disabled="!formValid">OK</v-btn>
                  <v-btn color="brown darken-2" flat @click.native="editDialog = false">Annuler</v-btn>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>
   </v-layout>


   </div>
</template>

<script>
   import Vue from 'vue'
   import config from '@/config'
   import fuzzy from '@/utilities/fuzzy.js'
   import moment from 'moment'
   import _ from 'lodash'
   import { required } from 'vuelidate/lib/validators'

   export default {

      props: {
         userId: Number,
         date: String,
         index: Number,
      },

      data () {
         return {
            create: false,
            editDialog: false,
            deleteDialog: false,

            foodItems: [],
            foodSearchInput: null,
            foodSearchLoading: false,

            mealElementToEdit: {},
            choosenFood: null,
            choosenFoodPortions: null,
            choosenFoodPortion: null,
            choosenFoodPortionCount: null,
            choosenWeight: null,

            mealElementToDelete: {},
            zoomImage: false,
            mealElementToZoomIn: {},

            tickLabels: [
               "\u00BC", "\u00BD", "\u00BE",
               '1', '', '', '',
               '2', '', '', '',
               '3', '', '', '',
               '4', '', '', '',
               '5',
            ],
         }
      },

      computed: {
         mealNames() {
            return config.MEAL_TYPE_LIST.map(index => config.MEAL_TYPES[index]['name'])
         },
         mealId() {
            if (this.$store.state.meals.user2date2index2meal[this.userId]
                  && this.$store.state.meals.user2date2index2meal[this.userId][this.date]
                  && this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]) {
               return this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]
            } else {
               return null
            }
         },
         meal() {
            if (this.mealId) {
               return this.$store.state.meals.meals[this.mealId]
            } else {
               return null
            }
         },
         mealElements() {
            if (this.$store.state.meals.meal2mealElementList.hasOwnProperty(this.mealId)) {
               return this.$store.state.meals.meal2mealElementList[this.mealId].map(mealElementId => this.$store.state.meals.mealElements[mealElementId])
            } else {
               return []
            }
         },

         displayDate () {
            return moment(this.date).format("dddd Do MMMM YYYY")
         },
         fuzzyChoosenFoodPortionWeight () {
            return fuzzy.parse(this.choosenFoodPortion.qty)
         },
         choosenWeightErrors () {
            const errors = []
            if (!this.$v.choosenWeight.$dirty) return errors
            !this.$v.choosenWeight.required && errors.push("Le poids est obligatoire")
            !this.$v.choosenWeight.isWeightCorrect && errors.push("Le poids est mal écrit")
            return errors
         },
         formValid () {
            return this.$v.choosenWeight.required && this.$v.choosenWeight.isWeightCorrect
         },
      },

      validations: {
         choosenWeight: {
            required,
            isWeightCorrect (value) {
               if (value === '') return true
               if (value === null) return true
               return fuzzy.parse(value) !== null
            },
         },
      },

      watch: {
         foodSearchInput (val) {
            val && this.querySelections(val)
         },
         'choosenFood.id': async function (newVal, oldVal) {
            if (newVal) {
               try {
                  this.choosenFoodPortions = await this.$store.dispatch('meals/GET_FOOD_FOODPORTIONS', newVal)
                  if (this.choosenFoodPortions.length === 1) {
                     this.choosenFoodPortion = this.choosenFoodPortions[0]
                     this.choosenFoodPortionCount = 1.
                     this.choosenWeight = this.choosenFoodPortion.qty
                  }
               } catch(err) {
                  console.log(err)
               }
            }
         },
      },

      methods: {
         clone (meal) {
            return _.clone(meal)
         },
         pictPath (pict) {
            return `/static/media/${pict}`
         },
         addMealElement () {
            this.mealElementToEdit = {}
            this.choosenFood = null
            this.choosenFoodPortions = null
            this.choosenFoodPortion = null
            this.choosenFoodPortionCount = null
            this.choosenWeight = null
            this.create = true
            this.editDialog = true
         },
         changeFood () {
            this.choosenFood = null
            this.choosenFoodPortions = null
            this.choosenFoodPortion = null
            this.choosenFoodPortionCount = null
            this.choosenWeight = null
         },
         async editMealElement (mealElement) {
            this.foodSearchLoading = true
            try {
               this.choosenFood = await this.$store.dispatch('meals/GET_FOOD', mealElement.food)
               this.choosenFoodPortions = await this.$store.dispatch('meals/GET_FOOD_FOODPORTIONS', mealElement.food)
               if (mealElement.portion) {
                  this.choosenFoodPortion = _.find(this.choosenFoodPortions, portion => (portion.id === mealElement.portion))
                  this.choosenFoodPortionCount = mealElement.nbportion
               } else {
                  if (this.choosenFoodPortions.length === 1) {
                     this.choosenFoodPortion = this.choosenFoodPortions[0]
                     let fuzzyWeight = fuzzy.parse(mealElement.weight)
                     let fuzzyPortionCount = fuzzy.multiplyByScalar(fuzzyWeight, 1 / parseFloat(this.choosenFoodPortion.qty))
                     this.choosenFoodPortionCount = fuzzy.middleValue(fuzzyPortionCount)
                  } else {
                     this.choosenFoodPortion = null
                     this.choosenFoodPortionCount = null
                  }
               }
               this.choosenWeight = mealElement.weight
            } finally {
               this.foodSearchLoading = false
            }
            this.mealElementToEdit = _.clone(mealElement)
            this.create = false
            this.editDialog = true
         },
         changeFoodPortion () {
            this.choosenFoodPortion = null
            this.choosenFoodPortionCount = null
            this.choosenWeight = null
         },
         chooseFoodPortion (foodPortion) {
            this.choosenFoodPortion = foodPortion
            this.choosenFoodPortionCount = 1
            this.choosenWeight = fuzzy.format(fuzzy.parse(this.choosenFoodPortion.qty))
         },
         async deleteMealElement () {
            try {
               await this.$store.dispatch('meals/DELETE_MEAL_ELEMENT', this.mealElementToDelete)
            } catch(err) {
               console.log(err)
            }
         },
         mealElementQuantityDescription (mealElement) {
            let result = ''
            if (mealElement.portion) {
               if (mealElement.nbportion === '1.00') {
                  result += mealElement.portion_name
               } else if (mealElement.nbportion === '0.25') {
                  return "\u00BC x " + mealElement.portion_name
               } else if (mealElement.nbportion === '0.50') {
                  return "\u00BD x " + mealElement.portion_name
               } else if (mealElement.nbportion === '0.75') {
                  return "\u00BE x " + mealElement.portion_name
               } else {
                  let nbPortionStr = parseFloat(mealElement.nbportion).toLocaleString('fr-FR', { maximumFractionDigits: 2 })
                  result += `${nbPortionStr} x ${mealElement.portion_name}`
               }
            } else {
               result += `${mealElement.weight} gr`
            }
            return result
         },
         async querySelections (text) {
            //console.log('search text', text)
            let authData = this.$store.state.authenticationData
            this.foodSearchLoading = true
            try {
               this.foodItems = await this.$store.dispatch('meals/GET_FOOD_SEARCH', text)
            } finally {
               this.foodSearchLoading = false
            }
         },
         onSliderChange (nbPortion) {
            this.choosenWeight = fuzzy.format(fuzzy.multiplyByScalar(this.fuzzyChoosenFoodPortionWeight, nbPortion))
         },
         onWeightChange (weight) {
            console.log('onWeightChange')
            try {
               let fuzzyWeight = fuzzy.parse(weight)
               let fuzzyCount = fuzzy.divide(fuzzyWeight, this.fuzzyChoosenFoodPortionWeight)
               this.choosenFoodPortionCount = fuzzy.middleValue(fuzzyCount)
            } catch(error) {
               this.choosenFoodPortionCount = 1
            }
         },
         onWeightChangeDebounced (weight) {
            console.log('onWeightChangeDebounced')
            let self = this
            _.debounce(() => {
               self.onWeightChange(weight)
            }, 1000)()
         },
         debouncedCreateOrUpdate: function() {
            let self = this
            _.debounce(() => {
               self.editDialog = false
               self.createOrUpdateMealElement(this.mealElementToEdit)
            }, 300, { 'leading': true, 'trailing': false })()
         },
         async createOrUpdateMealElement(mealElement) {
            let mealId_ = this.mealId
            if (mealId_ === null) {
               // meal does not exist yet: create it
               let meal = await this.$store.dispatch('meals/POST_USER_MEAL', {
                  user: this.userId,
                  date: this.date,
                  index: this.index,
               })
               mealId_ = meal.id
            }
            mealElement.meal = mealId_
            mealElement.food = this.choosenFood.id
            if (this.choosenFoodPortion) {
               mealElement.portion = this.choosenFoodPortion.id
               // 2 decimal places to make sure it does not get error 400 against Django model MealElement.nbportion
               mealElement.nbportion = parseFloat(Math.round(this.choosenFoodPortionCount * 100) / 100).toFixed(2)
            }
            mealElement.weight = this.choosenWeight
            try {
               let action = this.create ? 'meals/POST_MEAL_ELEMENT' : 'meals/PUT_MEAL_ELEMENT'
               await this.$store.dispatch(action, mealElement)
            } catch(err) {
               console.log(err)
            }
            if (mealElement.portion) {
               // lookup for existing favorite
               let favorites = await this.$store.dispatch('meals/GET_FAVORITE', { userId: this.meal.user, index: this.meal.index, portion: mealElement.portion, nbportion: mealElement.nbportion })
               if (favorites.length === 0) {
                  // create new favorite
                  this.$store.dispatch('meals/POST_FAVORITE', { user: this.meal.user, index: this.meal.index, portion: mealElement.portion, nbportion: mealElement.nbportion })
               }
            }
         },
      },

   }
</script>




// WEBPACK FOOTER //
// UserMealElements.vue?e7840eb6